// src/components/Modelo/ModeloCatalogo.js
import React from 'react';
import './ModeloCatalogo.css';

// Definir el enlace del catálogo como una variable
const catalogoUrl = 'https://heyzine.com/flip-book/f34195a0ca.html#page/18';

const ModeloCatalogo = () => {
  return (
    <div className="modelo-catalogo" style={{ backgroundImage: `url(/images/servicios/banner-servicios.jpg)` }}>
      <button className="modelo-catalogo-button" onClick={() => window.location.href = catalogoUrl}>
        VER CATÁLOGO
      </button>
    </div>
  );
};

export default ModeloCatalogo;
